export default class ToggleIframeModal {
  constructor(element) {
    let that = this;

    let toggleBtnClass = element.getAttribute("data-trigger");
    let toggleBtn = element.getElementsByClassName(toggleBtnClass);
    this.modalClass = element.getAttribute("data-modal");
    this.mediaId = element.getAttribute("data-id");
    this.modal = element.getElementsByClassName(this.modalClass)[0];
    this.iframeContent = element.getAttribute("data-content");
    this.targetClass = element.getAttribute("data-target");
    this.targetEl = element.getElementsByClassName(this.targetClass)[0];

    // Open modal on page load if param passed with matching id
    let url = String(window.location.href);
    let vars = url.split("?");
    if (vars.length > 0) {
      for (let i = 0; i < vars.length; i++) {
        let urlId = vars[i].replace("id=", "");
        if (urlId == this.mediaId) {
          this.toggleFromUrl();
        }
      }
    }

    /*
     * Eventlisteners
     */
    // Close on window click
    document.addEventListener(
      "click",
      function (e) {
        that.closeOnDocumentClick(e);
      },
      false,
    );

    // Toggle on button click
    for (var i = 0; i < toggleBtn.length; i++) {
      toggleBtn[i].addEventListener(
        "click",
        function () {
          that.toggle();
        },
        false,
      );
    }
  }

  toggle(e) {
    if (this.modal.hasAttribute("aria-hidden")) {
      this.targetEl.innerHTML = this.iframeContent;
      this.modal.removeAttribute("aria-hidden");
      history.pushState({}, null, "?id=" + this.mediaId);
    } else {
      this.targetEl.innerHTML = "";
      this.modal.setAttribute("aria-hidden", "true");
      history.pushState({}, null, window.location.pathname);
    }
  }

  toggleFromUrl() {
    if (this.modal.hasAttribute("aria-hidden")) {
      this.targetEl.innerHTML = this.iframeContent;
      this.modal.removeAttribute("aria-hidden");
    } else {
      this.targetEl.innerHTML = "";
      this.modal.setAttribute("aria-hidden", "true");
    }
  }

  // Close modal on click outside content
  closeOnDocumentClick(e) {
    if (e.target.classList.contains("iframe-modal")) {
      let modals = document.getElementsByClassName(this.modalClass);
      for (let i = 0; i < modals.length; i++) {
        modals[i].setAttribute("aria-hidden", "true");
        let iframedContent = modals[i].getElementsByClassName(
          this.targetClass,
        )[0];
        iframedContent.innerHTML = "";
        history.pushState({}, null, window.location.pathname);
      }
    }
  }
}
